// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"Publications_cardContainer__1fkq_"};